const initFormatter = (header = {}) => {
    if (header.formatter) return header.formatter;
    switch (header.formatterType) {
        case "number": {
            return (value) => value?.format?.() || value;
        }
        case "date": {
            return (value) => value?.toDate?.() || value;
        }
        case "datetime": {
            return (value) => value?.toDateTime?.() || value;
        }

        default: {
            return (value) => value ?? "-";
        }
    }
};

export const initDataTableHeaders = (headers = [], { showsDivider = true, className = "white-space-pre-line", cellClass = "caption line-height-1-5 white-space-pre-line" } = {}) => {
    return headers.map((header, index, array) => ({
        ...header,

        sortable: header.sortable ?? false,

        formatter: initFormatter(header),

        align: header.align ?? "start",
        divider: header?.divider || showsDivider ? index != array.length - 1 : false,

        class: ((header.class || "") + ` ${className}`).trim(),
        cellClass: ((header.cellClass || "") + ` ${cellClass}`).trim(),
    }));
};
